import { AGING_BUCKETS, PROMISE_STATUS, type AgingBucketId, type PromiseStatus } from '@tumin/domain'
import type { StatusTone } from '@/components/status-badge'

/** Tramos de la cola de mora: todos menos "al día" (la cola solo tiene atrasados). */
export const QUEUE_BUCKETS = AGING_BUCKETS.filter((bucket) => bucket.id !== 'current')
/** Tramo "al día" (no aparece en la cola). */
export const CURRENT_BUCKET: AgingBucketId = 'current'
/** Permiso para registrar gestiones (y recibir cartera como gestor). */
export const COLLECTIONS_MANAGE_PERMISSION = 'collections:manage' as const
/** Permiso para repartir la cartera entre gestores (supervisión). */
export const COLLECTIONS_ASSIGN_PERMISSION = 'collections:assign' as const
/** Permiso de quienes originan préstamos (asesores), para el filtro de asesor. */
export const ADVISOR_PERMISSION = 'loans:originate' as const
/** Permiso para ver reportes (la dona usa el reporte de antigüedad si está disponible). */
export const REPORTS_PERMISSION = 'reports:read' as const
/** Valor del parámetro `unassigned` del API. */
export const QUERY_TRUE = 'true'

/** Pestañas de la pantalla de cobranza. */
export const COLLECTIONS_TABS = ['queue', 'promises'] as const
/** Pestaña de cobranza. */
export type CollectionsTab = (typeof COLLECTIONS_TABS)[number]

/** Tono de la insignia de cada estado de promesa. */
export const PROMISE_STATUS_TONES: Record<PromiseStatus, StatusTone> = {
  [PROMISE_STATUS.pending]: 'info',
  [PROMISE_STATUS.kept]: 'success',
  [PROMISE_STATUS.broken]: 'critical',
}
